module.exports = __webpack_public_path__ + "img/top_up.734438d.png";